import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import random from 'lodash/random';

import imgixConfig from 'Config/imgix';
import KeyReveals from 'Helpers/Order/KeyReveals';
import RevealPrizeStep from 'Components/Order/KeyReveals/RevealPrizeStep';

import 'Components/Order/KeyReveals/Wheel/WheelReveal.scss';

export default function WheelRevealJingleJam({
  item,
  uniqueId,
  testReveal,
  viewKeys,
  mysteryGameDetails,
  wheelImgSrc,
}) {
  const [degrees, setDegrees] = useState(0);
  const [itemName, setItemName] = useState();
  const [showItem, setShowItem] = useState(false);

  useEffect(() => {
    const wheel = document.getElementById(`wheel-spin-${uniqueId}`);
    if (wheel) {
      wheel.addEventListener('transitionend', () => {
        // This enables the spin to start again and reset the rotation to the 360 axis.
        const actualDeg = degrees % 360;
        wheel.style.transition = 'none';
        wheel.style.transform = `rotate(${actualDeg}deg)`;
        // Pause before showing user what they have won
        window.setTimeout(() => { setShowItem(true); }, 500);
      });
    }
    // Remove EventListeners
    return () => {
      if (wheel) wheel.removeEventListener('transitionend', () => {});
    };
  }, [degrees, testReveal, uniqueId]);

  useEffect(() => {
    const wheel = document.getElementById(`wheel-spin-${uniqueId}`);

    let prizeName = item.name;
    if (get(mysteryGameDetails, 'name')) prizeName = mysteryGameDetails.name;
    if (testReveal) prizeName = KeyReveals.getAltTestWheelNumber();

    setItemName(KeyReveals.formatProductName(prizeName));

    let deg = 0;
    const numberOfSegments = 17;
    const numberOfRotations = 4;

    // Work our how many degrees of the wheel each segment represents.
    const segmentDegrees = 360 / numberOfSegments;

    // Get the number of the segment to land on. We need to minus 1 to land on the correct segment.
    const segmentNumber = KeyReveals.getAltWheelNumber(prizeName) - 1;

    // To make the animation feel more relistic, we dont want the animation to finish in the middle of each segment.
    // First we need to minus half the segment degrees.
    // This is a negative number because we need to rotate backwards.
    const halfSegmentDegrees = Math.ceil(segmentDegrees / -2);

    // Next we want to add a random number of degrees within the segment.
    // We start 3 degrees into the segment and stop 3 degrees before the end of the segment.
    // This is to stop the arrow falling on the line between segments.
    const degreesToAdd = random(3, Math.floor(segmentDegrees - 3));

    // Add these numbers together to create our random offset.
    const rand = halfSegmentDegrees + degreesToAdd;

    // Rotate the wheel fully by the number of rotations, minusing the amount needed to land on the correct segment, plus the extra random degrees
    deg = ((numberOfRotations * 360) + rand) - (segmentDegrees * segmentNumber);
    setDegrees(deg);

    if (wheel && segmentNumber !== 0) {
      window.setTimeout(() => {
        wheel.style.transition = 'all 8s cubic-bezier(0, 0, .1, 1)';
        wheel.style.transform = `rotate(${deg}deg)`;
      }, 1000);
    }
  }, [item, testReveal, mysteryGameDetails, uniqueId]);

  const showGlass = false;

  return (
    <div className="WheelReveal">
      <div className="WheelReveal__wheelArrowContainer">
        <div className="WheelReveal__wheelArrowContainer__arrow">
          <img
            src={`https://fanatical.imgix.net/production/assets/misc/wheel-arrow-2.png?${imgixConfig}`}
            alt="Arrow"
            className="wheel-arrow"
          />
        </div>
        <div className="WheelReveal__wheelArrowContainer__wheel">
          {showGlass &&
            <img
              src={`https://fanatical.imgix.net/production/assets/mystery/spin-the-wheel/2023/black-friday-wheel-glass.png?${imgixConfig}`}
              alt="Glass"
              className="WheelReveal__wheelArrowContainer__wheel__glass"
            />
          }
          <img
            src={wheelImgSrc}
            alt="Spin To Win Wheel"
            className="wheel"
            id={`wheel-spin-${uniqueId}`}
          />
        </div>
      </div>

      {showItem &&
        <RevealPrizeStep
          showCard
          type="wheel"
          testReveal={testReveal}
          viewKeys={viewKeys}
          prizeName={itemName}
          game={item}
        />
      }
    </div>
  );
}

WheelRevealJingleJam.propTypes = {
  item: PropTypes.shape({}),
  mysteryGameDetails: PropTypes.shape({}),
  testReveal: PropTypes.bool,
  uniqueId: PropTypes.string,
  viewKeys: PropTypes.func,
  wheelImgSrc: PropTypes.string,
};

WheelRevealJingleJam.defaultProps = {
  item: {},
  mysteryGameDetails: {},
  testReveal: false,
  uniqueId: '',
  viewKeys: () => {},
  wheelImgSrc: '',
};
